// JsFromRoutes CacheKey fefa472e4f498e8eeb0ce58ef8068c4a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_text_modules/search'),
  duplicate: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_text_modules/:id/duplicate'),
  typeaheadSelect: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_text_modules/typeahead_select'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_text_modules'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/hero_text_modules'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/hero_text_modules/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/hero_text_modules/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/hero_text_modules/:id'),
}
